// CreatingCampaign.js
import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function CreatingCampaign() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Creating a Campaign
      </Typography>

       <Typography paragraph>
        A send-out in PostSheet is called a <strong>Campaign</strong> (or “Job”).
        Follow these five steps:
      </Typography>

      <List className="steps-vertical" sx={{marginLeft:"2rem"}}>
        <ListItem sx={{marginLeft:"1rem"}}>
          <Typography variant="h4">1&nbsp;·&nbsp;Select a data source</Typography>
          <img src="../../static/docs/NewCampaign.jpg" alt="" className="step-img" />
        </ListItem>

        <ListItem sx={{marginLeft:"1rem"}}>
          <Typography variant="h4">
            2&nbsp;·&nbsp;Configure the source (<code>.xls</code> example)
          </Typography>
          <img src="../../static/docs/datasourceconfigure.jpg" alt="" className="step-img" />
        </ListItem>

        <ListItem sx={{marginLeft:"1rem"}}>
          <Typography variant="h4">3&nbsp;·&nbsp;Choose an action (Email / WhatsApp / SMS)</Typography>
          <img src="../../static/docs/actionselect.jpg" alt="" className="step-img" />
        </ListItem>

        <ListItem sx={{marginLeft:"1rem"}}>
          <Typography variant="h4">4&nbsp;·&nbsp;Write your message</Typography>
          <Typography paragraph>
                      To add data from your spreadsheet click on the button chips of the corresponding columns.
                    </Typography>
          <img src="../../static/docs/configureemail.jpg" alt="" className="step-img" />
        </ListItem>

        <ListItem sx={{marginLeft:"1rem"}}>
          <Typography variant="h4">5&nbsp;·&nbsp;Preview &amp;, schedule and settings</Typography>
          <img src="../../static/docs/previewcampaign.jpg" alt="" className="step-img" />
        </ListItem>
      </List>

<Box sx={{backgroundColor: "#f8de73", borderRadius: '4px', p: 1}}>
      <Typography paragraph sx={{ mt: 2 }}>
        <strong>Tip:</strong> the first row of every sheet or table must contain
        clean column headers (no blanks or special characters). One header must
        be the recipient’s <em>email</em> or <em>phone number</em>. Remaining
        columns become dynamic merge fields. Invalid contacts are skipped, but
        the rest of the campaign sends as normal.
      </Typography>
      </Box>
    </Box>
  );
}
